import { Point, Rectangle } from "./geometry";

/**
 * Rectangular area with both normalized and pixel coordinates. It supports parent-children relationships
 *
 * TODO: pivot, anchors
 */
export class ScreenRectangle
{    
    public name:string = "";

    // Normalized position within parent
    public localPosition:Point = new Point(0.5,0.5);

    // Local scaling factor
    public localScale:Point = new Point(1,1);

    // Total scaling factor (product of scaling factors of all ancestors and localScale)
    public scale:Point = new Point(1,1);

    // Normalized width (used to recalculate screen size when parent is defined)
    public localWidth:number = 1; 

    // Normalized height (used to recalculate screen size when parent is defined)
    public localHeight:number = 1;

    // Width of content in pixels (used to calculate screen size when no parent is defined)
    public baseWidth:number = 0;

    // Height of content in pixels (used to calculate screen size when no parent is defined)
    public baseHeight:number = 0;

    // Width in screen coordinates after all transformations
    public screenWidth:number = 0;

    // Height in screen coordinates after all transformations
    public screenHeight:number = 0;

    // Position in screen cooodinates
    public screenPosition:Point = new Point();

    // Array of immediate children
    public children:ScreenRectangle[] = [];

    // Reference to parent
    public parent:ScreenRectangle = null;

    // Sorting order
    public z:number = 0;

    // Shorthand property for rectangle structure
    get rect():Rectangle{
        return new Rectangle(this.screenWidth, this.screenHeight, this.screenPosition.x - 0.5 * this.screenWidth, this.screenPosition.y - 0.5 * this.screenHeight);
    }

    public constructor()
    {

    }

    public addChild(child:ScreenRectangle)
    {
        if (child.parent != null)
        {
            child.parent.removeChild(child);
        }
        child.parent = this;
        this.children.push(child);
        child.recalculate();
    }

    public removeChild(child:ScreenRectangle)
    {
        let index = this.children.indexOf(child);
        if (index >= 0)
        {
            this.children.splice(index,1);
        }
    }

    /**
     * Updates screen coordinates
     */
    public recalculate(onlyChildren:boolean = false)
    {
        if (!onlyChildren)
        {
            if (this.parent)
            {
                this.screenWidth = this.parent.screenWidth * this.localWidth * this.localScale.x;
                this.screenHeight = this.parent.screenHeight * this.localHeight * this.localScale.y;
                this.screenPosition = this.parent.screenPosition.add( this.localPosition.sub(new Point(0.5,0.5)).mulXY(this.parent.screenWidth, this.parent.screenHeight) );    
                this.scale = this.parent.scale.mulXY(this.localScale.x, this.localScale.y);
            }
            else
            {
                this.screenWidth = this.baseWidth * this.localWidth * this.localScale.x;
                this.screenHeight = this.baseHeight * this.localHeight * this.localScale.y;
                this.scale = this.localScale;
            }    
        }

        for (let i = 0; i < this.children.length; i++)
        {
            this.children[i].recalculate();
        }
    }    

    /**
     * Converts point in screen coordinates to point in local normalized coordinates
     * @param s
     */
    public screenToLocal(s:Point):Point
    {
        let sdist = s.sub(this.screenPosition);
        //let normdist = sdist.mulXY(1./this.screenWidth/this.localScale.x, 1./this.screenHeight / this.localScale.y);
        let normdist = sdist.mulXY(1./this.screenWidth, 1./this.screenHeight);
        let result = new Point(0.5, 0.5).add(normdist);
        return result;
    }

    /**
     * Converts point in local normalized coordinates to point in screen coordinates
     * @param uv 
     */
    public localToScreen(uv:Point):Point
    {
        return this.screenPosition.add(uv.subXY(0.5, 0.5).mulXY(this.screenWidth, this.screenHeight));
    }

    public changeParent(newParent:ScreenRectangle)
    {        
        // determine new local position
        let sp:Point = this.parent.localToScreen(this.localPosition);

        let lp:Point = newParent.screenToLocal(sp);

        // determine new localWidth and localHeight, keeping localScale the same
        let lw = this.screenWidth / newParent.screenWidth / this.localScale.x;
        let lh = this.screenHeight / newParent.screenHeight / this.localScale.y;
        this.localPosition = lp;
        this.localWidth = lw;
        this.localHeight = lh;

        newParent.addChild(this);
        newParent.recalculate();
    }
}

